import { useState } from "react";

import { LoadingButton } from "@mui/lab";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useGetUpcomingInvoiceQuery, useLazyGetXlsxUpcomingInvoiceQuery } from "src/_api/mapitShipInvoice";
import { DownloadExcelDialog } from "src/_modules/common";
import InvoiceOrdersDialog from "./InvoiceOrdersDialog";

export default function UpcomingInvoicesDetailsDialog() {

    const { t } = useTranslation();

    const { data: invoice } = useGetUpcomingInvoiceQuery({});

    // Dialog state
    const [open, setOpen] = useState(false);

    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);

    const [
        getXlsxUpcomingInvoice,
        {
            isLoading: getXlsxUpcomingInvoiceLoading,
            isSuccess: getXlsxUpcomingInvoiceIsSuccess,
            error: getXlsxUpcomingInvoiceError
        }
    ] = useLazyGetXlsxUpcomingInvoiceQuery();

    const [dowloadExcelIsSuccess, setDowloadExcelIsSuccess] = useState(false);
    const [dowloadExcelError, setDowloadExcelError] = useState(false);
    const [openExcelDialog, setOpenExcelDialog] = useState(false);

    const sendExcelFileToEmailHandler = async ({ email }) => {
        try {
            await getXlsxUpcomingInvoice({ email }).unwrap();
            setDowloadExcelIsSuccess(true);
            setTimeout(() => {
                closeDownloadExcelDialogHandler();
            }, 2000);
        } catch (error) {
            setDowloadExcelError(error);
        }
    }

    const closeDownloadExcelDialogHandler = () => {
        setOpenExcelDialog(false);
        setDowloadExcelIsSuccess(false);
        setDowloadExcelError(false);
    }

    const openExcelDialogHandler = () => {
        setOpenExcelDialog(true);
    }

    //=================Invoice orders dialog=====================
    const [invoiceId, setInvoiceId] = useState(null)
    const [openInvoiceOrdersDialog, setOpenInvoiceOrdersDialog] = useState(false)

    const openDialogHandler = (invoiceId) => {
        setInvoiceId(invoiceId)
        setOpenInvoiceOrdersDialog(true)
    }

    const closeDialogHandler = () => {
        setOpenInvoiceOrdersDialog(false)
        setInvoiceId(null)
    }

    return (
        <>
            <DownloadExcelDialog
                open={openExcelDialog}
                onSend={sendExcelFileToEmailHandler}
                onClose={closeDownloadExcelDialogHandler}
                loading={getXlsxUpcomingInvoiceLoading}
                isSuccess={dowloadExcelIsSuccess}
                error={dowloadExcelError}
                disabledSend={false}
                options={["EMAIL"]}
            />            <InvoiceOrdersDialog
                open={openInvoiceOrdersDialog}
                onClose={closeDialogHandler}
                invoiceId={invoiceId}
            />

            {/* Details Button */}
            <Button
                variant="outlined"
                onClick={openDialog}
                sx={{ textTransform: "none" }}
                size="small"
            >
                {t("Details")}
            </Button>

            <Dialog
                open={open}
                onClose={closeDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>{t("Upcoming Transfer")}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Invoice No.")}
                                </Typography>
                                <Typography>
                                    {invoice?.invoiceNumber}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Completed orders")}
                                </Typography>
                                <Typography>
                                    {invoice?.completedOrdersCount}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Amount Due")}
                                </Typography>
                                <Typography>
                                    {invoice?.dueAmount?.toFixed(2)}
                                </Typography>
                            </Box>
                        </Grid>
                        {/* <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Total Wallet Top-Up")}
                                </Typography>
                                <Typography>
                                    {invoice?.totalChargeWallet?.toFixed(2)}
                                </Typography>
                            </Box>
                        </Grid> */}
                        <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Total COD")}
                                </Typography>
                                <Typography>
                                    {invoice?.totalCodAmount?.toFixed(2)}
                                </Typography>
                            </Box>
                        </Grid>
                        {/* <Grid item md={6} xs={6}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {t("Returned orders")}
                                </Typography>
                                <Typography>
                                    {invoice?.returnedOrders?.length}
                                </Typography>
                            </Box>
                        </Grid> */}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        sx={{ textTransform: "none" }}
                        onClick={closeDialog}
                        variant="contained"
                    >
                        {t("Close")}
                    </Button>
                    {!!getXlsxUpcomingInvoiceError && <Typography color="error">{t(getXlsxUpcomingInvoiceError)}</Typography>}
                    {getXlsxUpcomingInvoiceIsSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                    <Box mr="auto" />
                    <Button
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        onClick={() => openDialogHandler(invoice?.id)}
                        disabled={!invoice?.completedOrdersCount && !invoice?.totalAmount} //!invoice?.returnedOrders?.length &&
                    >
                        {t("Show")}
                    </Button>
                    <LoadingButton
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        onClick={openExcelDialogHandler}
                        disabled={!invoice?.completedOrdersCount && !invoice?.totalAmount}//!invoice?.returnedOrders?.length &&
                    >
                        {t("Download")}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}